import { render, staticRenderFns } from "./SpThreeModule1.vue?vue&type=template&id=dfb6a3cc&scoped=true"
import script from "./SpThreeModule1.vue?vue&type=script&lang=js"
export * from "./SpThreeModule1.vue?vue&type=script&lang=js"
import style0 from "./SpThreeModule1.vue?vue&type=style&index=0&id=dfb6a3cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb6a3cc",
  null
  
)

export default component.exports